define('lq/types',[
    'globalize',
    'underscore',
    'lq/constants'
], function (globalize, _, constants) {

    var yyyy_mm_dd = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    var isDate = function (value) {
        return value != null &&
            (_.isDate(value) || (value.constructor === String && value.match(yyyy_mm_dd) != null));
    };

    var isString = function (value) {
        return typeof (value) === 'string';
    };

    var isBoolean = function (value) {
        return typeof (value) === 'boolean';
    };

    var parseBoolean = function (value) {
        value = value.toLowerCase();

        if (value === 'true')
            return true;

        if (value === 'false')
            return false;

        throw new Error('The value "' + value + '" cannot be converted to a boolean.');
    };

    var parseDate = function (value) {
        if (_.isDate(value))
            return value;

        return globalize.parseDate(value, constants.licquidDateFormat);
    };

    var getTypeOfValue = function (value) {
        if (typeof value === 'number' && !isNaN(value)) {
            return Number.isInteger(value) ? constants.valueTypes.integer : constants.valueTypes.decimal;
        } else {
            var safeString = String(value);
            if (safeString.trim() !== '' && !isNaN(safeString)) {
                const num = Number(safeString);
                return Number.isInteger(num) ? constants.valueTypes.integer : constants.valueTypes.decimal;
            }
        }

        const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
        if (value instanceof Date || isoRegex.test(value)) {
            return constants.valueTypes.dateTime;
        }

        return constants.valueTypes.string;
    };

    return {
        isDate: isDate,
        isString: isString,
        isBoolean: isBoolean,
        parseBoolean: parseBoolean,
        parseDate: parseDate,
        getTypeOfValue: getTypeOfValue,
    };
});
